import { render } from "./ProjectsInfo.vue?vue&type=template&id=00b9a1e6&scoped=true"
import script from "./ProjectsInfo.vue?vue&type=script&lang=js"
export * from "./ProjectsInfo.vue?vue&type=script&lang=js"

import "./ProjectsInfo.vue?vue&type=style&index=0&id=00b9a1e6&scoped=true&lang=scss"
import "./ProjectsInfo.vue?vue&type=style&index=1&id=00b9a1e6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b9a1e6"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTr,QTooltip,QBtn,QPopupProxy,QCard,QLinearProgress,QChip,QSpinner,QToggle,QDrawer,QDialog,QCardSection,QCardActions,QSeparator,QBtnToggle,QSelect,QTable});qInstall(script, 'directives', {ClosePopup});
